import { render, staticRenderFns } from "./virtual.vue?vue&type=template&id=1086e178"
import script from "./virtual.vue?vue&type=script&lang=js"
export * from "./virtual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports